import { seededShuffle } from "./seeded-shuffle";

export const QUIZ_DISPLAY_SHUFFLE_CHANNELS = [
	"mcs",
	"mcm",
	"fib-bank",
	"word",
	"rank",
	"pair-left",
	"pair-right",
] as const;

export type QuizDisplayShuffleChannel =
	(typeof QUIZ_DISPLAY_SHUFFLE_CHANNELS)[number];

/**
 * Stable display permutation for quiz player choices.
 * Composite seed: `${shuffleSeed}|${questionId}|${channel}`.
 */
export function shuffleAnswersForDisplay<T>(params: {
	items: readonly T[];
	seed: string;
	questionId: string;
	channel: QuizDisplayShuffleChannel;
}): T[] {
	return seededShuffle(
		params.items,
		`${params.seed}|${params.questionId}|${params.channel}`,
	);
}
